import { jsx as i } from "react/jsx-runtime";
import { UnauthenticatedAccountLink as A } from "./unauthenticated.js";
import { AuthenticatedAccountLink as h } from "./authenticated.js";
const k = (a) => {
  const {
    closeMenuModal: c,
    isAuthenticated: r,
    userImage: u,
    openAuthModal: s,
    logout: l,
    hasNotifications: d,
    isActive: t,
    isScrolledHeader: o,
    language: e,
    getTranslation: n,
    newChatUrl: m
  } = a;
  return r ? /* @__PURE__ */ i(
    h,
    {
      userImage: u,
      logout: l,
      hasNotifications: d,
      isActive: t,
      isScrolledHeader: o,
      closeMenuModal: c,
      language: e,
      getTranslation: n,
      newChatUrl: m
    }
  ) : /* @__PURE__ */ i(
    A,
    {
      openAuthModal: s,
      isActive: t,
      isScrolledHeader: o,
      language: e,
      getTranslation: n
    }
  );
};
export {
  k as AccountLink
};
